import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1246px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const AlbumCoverButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 300ms ease;

  &:hover {
    transform: scale(0.95);
  }
`;
